<div class="nivelaciones-report-container">
    <div class="report-header">
        <mat-form-field>
            <input matInput #input [matDatepicker]="picker" placeholder="Fecha de nivelaciones" [(ngModel)]="fechaPicker"
                (dateChange)="activarBoton()">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="navegarAFecha()" [disabled]="botonInactivo">
            Generar lista
        </button>
        <span class="spacer"></span>
        <button mat-button color="primary" (click)="imprimir()" *ngIf="dataSource">
            <mat-icon>print</mat-icon>
            Imprimir
        </button>
    </div>
    <mat-divider></mat-divider>
    <ng-container *ngIf="dataSource">
        <div id="print-section">
            <div class="header-table" *ngIf="fechaReporte.isValid()">
                <h4>Nivelaciones para el día {{fechaReporte | date: 'EEEE d \'de\' MMMM \'de\' y'}}</h4>
                <span class="spacer"></span>
                <small>Generado el {{fechaHoy | date: 'EEEE d \'de\' MMMM \'de\' y \'a las\' h:mm'}}</small>
            </div>
            <div>
                <mat-form-field class="full-width">
                    <input matInput (keyup)="filtroTexto($event.target.value)" placeholder="Filtro de texto">
                </mat-form-field>
            </div>
            <mat-table #table [dataSource]="dataSource" matSort>
                <ng-container matColumnDef="Curso">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="cell__short">Curso</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="cell__short">
                        {{element.curso}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Codigo">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="cell__short">Código</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="cell__short">
                        {{element.codigo}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Alumno">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="cell__long">Alumno</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="cell__long">
                        {{element.alumno}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Materias">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="cell__long">Materias</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="cell__long">
                        <span class="line-breaker">{{element.materias}}</span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Hora">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="cell__short">Hora</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="cell__short">
                        <span class="line-breaker">{{element.hora}}</span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Lugar">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="cell__long">Lugar</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="cell__long">
                        <span class="line-breaker">{{element.lugar}}</span>                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let element; columns: displayedColumns;">
                </mat-row>
            </mat-table>
        </div>
    </ng-container>
    <ng-template *ngIf="cargandoData">
        <p></p>
        <mat-spinner [mode]="'indeterminate'"></mat-spinner>
    </ng-template>
</div>
